import React, { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "../api";

// The short link a shop hands out. Resolves their chosen name to their profile.
const ShopBySlug = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    api.get(`/business/by-slug/${encodeURIComponent(slug)}`)
      .then((r) => navigate(`/business/${encodeURIComponent(r.data.name)}`, { replace: true }))
      .catch(() => navigate("/businesses", { replace: true }));
  }, [slug, navigate]);

  return (
    <div className="py-24 flex justify-center" data-testid="shop-by-slug">
      <Loader2 className="animate-spin text-muted-foreground" />
    </div>
  );
};

export default ShopBySlug;
